module.exports = __webpack_public_path__ + "static/media/starfighter.d5def82f.svg";